import type {z} from "zod";

import {ContactInputFields, PhoneNumberInput} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const contactInputFields = ContactInputFields.shape;

export const addClientContactNameSchema = requiredStringSchema(
  contactInputFields.name,
  contactFieldLabelIds.name,
);
export const addClientContactEmailSchema = contactInputFields.email.or(zod.literal(""));
export const addClientContactDescriptionSchema = contactInputFields.description;
export const addClientContactPhoneNumberSchema = PhoneNumberInput.shape.nationalNumber.optional();
export const addClientContactPhonePrefixSchema = PhoneNumberInput.shape.regionCode.optional();

const addClientContactFormFieldsSchema = zod.object({
  name: addClientContactNameSchema,
  description: addClientContactDescriptionSchema,
  email: addClientContactEmailSchema,
  phone: addClientContactPhoneNumberSchema,
  phonePrefix: addClientContactPhonePrefixSchema,
});

export const addClientContactFormSchema = addClientContactFormFieldsSchema.superRefine(
  (value, ctx) => {
    if (!value.email && !value.phone) {
      ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
    }
    if (value.phone && !value.phonePrefix) {
      ctx.addIssue({code: "custom", message: "Phone prefix is required", path: ["phonePrefix"]});
    }
  },
);
export type AddClientContactFormPayload = z.output<typeof addClientContactFormSchema>;

export const draftAddClientContactFormSchema = addClientContactFormFieldsSchema.partial();
export type DraftAddClientContactFormPayload = z.output<typeof draftAddClientContactFormSchema>;
